import { apiInstance } from '@diamond/shared/utils';

export interface EstimatedWeightProductImportResponse {
  success: boolean;
  message: string;
  data: {
    imported_count: number;
  };
}

const IMPORT_ENDPOINT =
  '/backoffice/master-data/product-payment-method-configurations/import';
const EXPORT_ENDPOINT =
  '/backoffice/master-data/product-payment-method-configurations/export';

export const EXPORT_FILENAME = 'product_payment_method_configurations.xlsx';

export const importEstimatedWeightProduct = async (
  token: string,
  file: File
): Promise<EstimatedWeightProductImportResponse> => {
  const formData = new FormData();
  formData.append('file', file, file.name);

  const response = await apiInstance(token, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).post<EstimatedWeightProductImportResponse>(IMPORT_ENDPOINT, formData);

  return response.data;
};

export const exportEstimatedWeightProduct = async (
  token: string
): Promise<Blob> => {
  const response = await apiInstance(token, {
    responseType: 'blob',
  }).get<Blob>(EXPORT_ENDPOINT);

  return response.data;
};
